import dayjs from 'dayjs'

const desc = (a, b, orderBy, extraData) => {
  if (orderBy === "progress") {
    if (b[orderBy] && a[orderBy])
      return b[orderBy] < a[orderBy] ? -1 : 1;
    else if (b[orderBy] == null && a[orderBy])
      return -1;
    else if (a[orderBy] == null && b[orderBy])
      return 1;
    else
      return 0;
  }
  if (orderBy == "readingTime") {
    const accuracyData = extraData['staffDashboardReadingTime'];
    let a1 = accuracyData.find(obj => obj.studentId == a.studentId).readingTime;
    let b1 = accuracyData.find(obj => obj.studentId == b.studentId).readingTime;
    let avg1 = a1.map((a) => a.secondsRead).reduce((a, b) => a + b, 0);
    let avg2 = b1.map((a) => a.secondsRead).reduce((a, b) => a + b, 0);
    
    return avg2 < avg1 ? -1 : 1;
  }
  if (orderBy == "sectionIndex") {
    if (parseInt(a[orderBy]) < parseInt(b[orderBy]))
      return 1;
    else
      return -1;
  }
  if (orderBy == "accuracy") {
    const accuracyData = extraData['staffDashboardAccuracy'];
    let a1 = accuracyData.find(obj => obj.studentId == a.studentId).accuracy;
    let b1 = accuracyData.find(obj => obj.studentId == b.studentId).accuracy;
    return a1 < b1 ? 1 : -1;
  }
  if (b[orderBy]) {
    if (b[orderBy] === null) return 1;
    if (a[orderBy] === null) return -1;
    if (typeof (b[orderBy]) === 'string' || typeof (a[orderBy]) === 'string'){
      if (b[orderBy].toLowerCase() < a[orderBy].toLowerCase()) {
        return -1;
      }
      if (b[orderBy].toLowerCase() > a[orderBy].toLowerCase()) {
        return 1;
      }
    }
    else {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
    }
  }
  return 0;
};

export const stableSort = (array, cmp) => {
  const stabilizedThis = Array.isArray(array) ? array.map((el, index) => [el, index]) : [];
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    else if (a[0] === null) {
      return 1;
    }
    else if (b[0] === null) {
      return -1;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
};

export const getSorting = (order, orderBy, extraData) => {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy, extraData) : (a, b) => -desc(a, b, orderBy, extraData);
};

export const capitalize = (str) => {
  return str.slice(0, 1).toUpperCase().concat(str.slice(1))
};

// Will make sure that random color is consistent
const _stringAsciiPRNG = (value, m) => {
  const charCodes = [...value].map(letter => letter.charCodeAt(0));
  const len = charCodes.length;

  const a = (len % (m - 1)) + 1;
  const c = charCodes.reduce((current, next) => current + next) % m;

  let random = charCodes[0] % m;
  for (let i = 0; i < len; i++)
    random = ((a * random) + c) % m;

  return random;
};

export const getRandomColor = (value, colors = ['#1C77C3',
  '#F39237',
  '#29b6f6',
  '#26c6da',
  '#00c4b5',
  '#EF476F',
  '#ffa726',
  '#06D6A0']) => {
  if (!value)
    return 'transparent';

  const colorIndex = _stringAsciiPRNG(value, colors.length);
  return colors[colorIndex];
};

export const states = [
  "Alaska",
  "Alabama",
  'Alberta',
  "Arkansas",
  "American Samoa",
  "Arizona",
  'British Columbia',
  "California",
  "Colorado",
  "Connecticut",
  "District of Columbia",
  "Delaware",
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Iowa",
  "Idaho",
  "Illinois",
  "Indiana",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Massachusetts",
  "Maryland",
  "Maine",
  'Manitoba',
  "Michigan",
  "Minnesota",
  "Missouri",
  "Mississippi",
  "Montana",
  "North Carolina",
  "North Dakota",
  "Nebraska",
  'New Brunswick',
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  'Newfoundland and Labrador',
  "Nevada",
  "New York",
  'Northwest Territories',
  'Nova Scotia',
  'Nunavut',
  "Ohio",
  "Oklahoma",
  'Ontario',
  "Oregon",
  "Pennsylvania",
  "Puerto Rico",
  'Prince Edward Island',
  'Quebec',
  "Rhode Island",
  'Saskatchewan',
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Virginia",
  "Virgin Islands",
  "Vermont",
  "Washington",
  "Wisconsin",
  "West Virginia",
  "Wyoming",
  'Yukon Territory'
];

export const sortedBooks_OLD = (books) => {
  
  const inProgressBooks = []
  const notStartedBooks = []
  const finishedBooks = []

  // split books into three groups based on currentProgress
  books.forEach(book => {
    const progress = book.progress !== null ? parseFloat(book.progress) : null

    if (progress > 99) {
      finishedBooks.push(book)
    } else if (book.lastRead !== null && ((book.progress > 0 && book.progress !== null ) || book.lastRead !== null)) {
      inProgressBooks.push(book)
    } else {
      notStartedBooks.push(book)
    }
  })

  // lastRead is the main thing to sort by
  const compareByLastRead = (bookA, bookB) => {
    const compareLastRead = (a, b) => {
      if (!a && !b) return 0
      if (!a) return 1
      if (!b) return -1
      return new Date(b) - new Date(a); // recent to beginning of list
    }

    return compareLastRead(bookA.lastRead, bookB.lastRead)
  }


  // Compare function for sorting in-progress books
  const compareInProgressBooks = (bookA, bookB) => {

    // sort mainly by lastRead date
    const lastReadComparison = compareByLastRead(bookA, bookB)
    if (lastReadComparison !== 0) {
      return lastReadComparison
    }

    // account for null or undefined progress
    const progressA = (bookA.progress === null || bookA.progress === undefined) ? 0 : bookA.progress
    const progressB = (bookB.progress === null || bookB.progress === undefined)? 0 : bookB.progress
    
    // if they're the same, leave them
    if (progressA === progressB) {
      return 0 
    }
    // or higher progress comes first
    return progressB - progressA 
  }


  // Sort in-progress books by lastRead and progress
  const sortedInProgressBooks = inProgressBooks.sort(compareInProgressBooks)

  // Sort not-started books by lastRead
  const sortedNotStartedBooks = notStartedBooks.sort(compareByLastRead)

  // Sort finished books by lastRead
  const sortedFinishedBooks = finishedBooks.sort(compareByLastRead)

  const sortedBooks = {
    currentBooks: [...sortedInProgressBooks, ...sortedNotStartedBooks],
    finishedBooks: [...sortedFinishedBooks]
  }

  return sortedBooks
};

export const formatDate = (dateString) => {
  const date = dayjs(dateString)
  const currentDate = dayjs()
  const differenceInDays = currentDate.diff(date, 'day')

  if (differenceInDays === 0) {
    return 'Today'
  } else if (differenceInDays === 1) {
    return 'Yesterday'
  } else if (differenceInDays <= 6) {
    return date.format('dddd')
  } else {
    return date.format('MM/DD/YYYY')
  }
}

// Helper function to normalize progress values
const normalizeProgress = (progress) => {
  if (!progress || progress < 0) return 0;
  if (progress >= 99) return 100;
  if (progress > 100) return 100;
  return Math.floor(progress * 10) / 10;
};

export const sortedBooks = (books) => {

    const inProgressBooks = []
    const notStartedBooks = []
    const finishedBooks = []

    let mostRecentBook = null

    // Identify the most recently read book
    books.forEach(book => {
        if (!mostRecentBook || new Date(book.lastRead) > new Date(mostRecentBook.lastRead)) {
            mostRecentBook = book;
        }
    })

    // Group books based on progress and normalize progress values
    books.forEach(book => {
        // Normalize the progress value for this book
        const normalizedBook = {
            ...book,
            progress: normalizeProgress(book.progress)
        };

        if (book === mostRecentBook) {
            // Update mostRecentBook with normalized progress
            mostRecentBook = normalizedBook;
            return;
        }

        const progress = normalizedBook.progress;

        if (progress >= 100) {
            finishedBooks.push(normalizedBook)
        } else if (book.lastRead !== null && ((progress > 0) || book.lastRead !== null)) {
            inProgressBooks.push(normalizedBook)
        } else {
            notStartedBooks.push(normalizedBook)
        }
    })

    // Sort function for lastRead date
    const compareByLastRead = (bookA, bookB) => {
        if (!bookA.lastRead && !bookB.lastRead) return 0
        if (!bookA.lastRead) return 1
        if (!bookB.lastRead) return -1
        return new Date(bookB.lastRead) - new Date(bookA.lastRead); // Recent to older
    };

    // Sort in-progress books by lastRead and progress
    const compareInProgressBooks = (bookA, bookB) => {
        const lastReadComparison = compareByLastRead(bookA, bookB)
        if (lastReadComparison !== 0) {
            return lastReadComparison
        }

        const progressA = (bookA.progress === null || bookA.progress === undefined) ? 0 : bookA.progress
        const progressB = (bookB.progress === null || bookB.progress === undefined) ? 0 : bookB.progress

      return progressB - progressA // Higher progress first
    }

    // Sort in-progress books by lastRead and progress
    const sortedInProgressBooks = inProgressBooks.sort(compareInProgressBooks)

    // Sort not-started books by lastRead
    const sortedNotStartedBooks = notStartedBooks.sort(compareByLastRead)

    // Sort finished books by lastRead
    const sortedFinishedBooks = finishedBooks.sort(compareByLastRead)

    // Place the most recent book at the top of inProgressBooks, if it's not null
    if (mostRecentBook) {
        sortedInProgressBooks.unshift(mostRecentBook)
    }

    // Combine all sorted books into the final array
    const sortedBooks = [...sortedInProgressBooks, ...sortedNotStartedBooks, ...sortedFinishedBooks]

    return sortedBooks
}

// Display-only formatters for BuddyBooks "book level" labels.
// Maps database values Level 1..6 (or raw 1..6) to display labels Level 100..600.
const extractLevelNumber = (raw) => {
  if (raw === null || raw === undefined) return null;
  if (typeof raw === 'number') return raw;
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (trimmed.toLowerCase() === 'all levels') return 'ALL';
    // Match "Level 1", "level 2", etc.
    const m = trimmed.match(/^level\s*(\d{1,3})$/i);
    if (m && m[1]) {
      return parseInt(m[1], 10);
    }
    // Pure number as string
    const n = parseInt(trimmed, 10);
    if (!Number.isNaN(n)) return n;
  }
  return null;
};

export const formatBookLevelDisplay = (rawLevel) => {
  const base = extractLevelNumber(rawLevel);
  if (base === 'ALL') return 'All Levels';
  if (base === null) return '';
  // If already a 100-level number, keep as is
  const displayNum = base >= 100 ? base : base * 100;
  return `Level ${displayNum}`;
};

export const formatBuddyBooksLevelDisplay = (rawLevel) => {
  // Alias for clarity at call sites; same mapping rules
  return formatBookLevelDisplay(rawLevel);
};
